import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: 'app-sidebar-resources',
  templateUrl: './sidebar-resources.component.html',
  styleUrls: ['./sidebar-resources.component.scss']
})
export class SidebarResourcesComponent implements OnInit {

  alertCode: string = '';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService) { }

  ngOnInit(): void {
  }
  async onSignOut() {
    const data:any = await this.authService.signOutUser();
    this.alertCode = 'auth/sign-out-ok';
    this.router.navigate(['/']);
  }
}
